<template>
  <div>
    <section style="margin-left: 20px; margin-top: 10px">
      <div class="form-group">
        <label class="control-label text-primary"
          >Institution / Consortium</label
        >
        <br />
        <div class="nav-tabs-custom">
          <ul class="nav nav-tabs">
            <li class="active">
              <a
                style="color: cornflowerblue"
                href="#tab_1"
                @click="config.partyType = 'organization'"
                data-toggle="tab"
              >
                Institution
              </a>
            </li>
            <li>
              <a
                style="color: cornflowerblue"
                href="#tab_2"
                data-toggle="tab"
                @click="config.partyType = 'consortium'"
              >
                Consortium
              </a>
            </li>
          </ul>
          <div class="tab-content">
            <div class="tab-pane active" id="tab_1">
              <Institution
                :filteredNames="namesFiltered"
                @rowClicked="config.selectedParty = $event"
              ></Institution>
            </div>
            <div class="tab-pane" id="tab_2">
              <Consortium
                @rowClicked="config.selectedParty = $event"
              ></Consortium>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Institution from "../usage/sections/Institution";
import Consortium from "../usage/sections/Consortium";

export default {
  data() {
    return {
      subscriptionFilter: {
        endDate_From: "",
        endDate_To: "",
        startDate_From: "",
        startDate_To: "",
        partyEmail: "",
        partyName: "",
        partyType: [],
        partner: [],
        transactionType: [],
      },
      config: {
        partyType: "organization",
        selectedParty: "",
        selectedPartyName: "",
      },
      namesFiltered: [],
      partyAssociation: {},
    };
  },
  created() {
    // initialize the filter values from the store.
    // this can then be persisted to DB.
    this.subscriptionFilter = this.filter;
    this.$store.dispatch("partner/getData");
  },
  computed: {
    ...mapGetters("subscription", ["data", "filter"]),
    partnerData() {
      return this.$store.getters["partner/data"];
    },
    filteredPrtrData() {
      return this.partnerData.filter((element) => {
        return !["phoenix"].includes(element.partnerId);
      });
    },
  },
  watch: {
    $route: "fetchData",
    "config.selectedParty": function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.onSubmit();
      }
    },
  },
  components: {
    Institution: Institution,
    Consortium: Consortium,
  },
  methods: {
    // ...mapActions({
    //   stateSubSearchByFilter: types.SUB_ACTION_FILTER,
    //   statePrtrGetData: types.PRTR_ACTION_GET_DATA,
    // }),
    fetchData() {
      if (
        this.$route.path == "/subscription" &&
        this.$route.query.submit == "true"
      ) {
        this.onSubmit();
      }
    },
    onSubmit() {
      this.subscriptionFilter = { partyName: this.config.selectedParty.name };
      // console.log(this.subscriptionFilter);
      this.$store.dispatch("subscription/setFilter", this.subscriptionFilter);
    },
  },
  mounted() {
    this.subscriptionFilter = this.config.selectedPartyName;

    if (this.$route.query.submit == "true") {
      this.onSubmit();
    }
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/paywall/subscription/SubscriptionFilter.vue